import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import {
  MERCHANT_CAMPAIGN_CCB_1,
  MERCHANT_CAMPAIGN_CCB_2,
  MERCHANT_CAMPAIGN_CCB_3,
  // MERCHANT_WING3,
} from '../../constants/merchant'

const defaultState = {
  ccb: {
    merchants: [
      { id: MERCHANT_CAMPAIGN_CCB_1 },
      { id: MERCHANT_CAMPAIGN_CCB_2 },
      { id: MERCHANT_CAMPAIGN_CCB_3 },
      // { id: MERCHANT_WING3 }, // ! test merchant
    ],
    floor: '',
    displayCCBCardOnlyDialog: false,
  },
}

export const campaign = handleActions({
  UPDATE_DISPLAY_CCB_CARD_ONLY_DIALOG: (state, action) => {
    return update(
      state, {
        ccb: {
          displayCCBCardOnlyDialog: {
            $set: action.payload.display, // boaol
          },
        },
      },
    )
  },
  UPDATE_FLOOR: (state, action) => {
    return update(
      state, {
        ccb: {
          floor: {
            $set: action.payload.floor, // string
          },
        },
      },
    )
  },
}, defaultState)

export default { campaign }



// WEBPACK FOOTER //
// ./src/reducers/components/campaign.js